import React from 'react';
import { motion } from 'framer-motion';

interface TypingDotsProps {
  className?: string;
}

const TypingDots: React.FC<TypingDotsProps> = ({ className }) => {
  const dot = {
    initial: { y: 0, opacity: 0.4 },
    animate: {
      y: [0, -4, 0],
      opacity: [0.4, 1, 0.4],
      transition: { repeat: Infinity, duration: 1, ease: 'easeInOut' }
    }
  };

  return (
    <div className={className}>
      <div className="flex items-center space-x-1">
        <motion.span className="w-2 h-2 bg-blue-600 rounded-full" variants={dot} initial="initial" animate="animate" />
        <motion.span className="w-2 h-2 bg-blue-600 rounded-full" variants={dot} initial="initial" animate="animate" transition={{ delay: 0.15 }} />
        <motion.span className="w-2 h-2 bg-blue-600 rounded-full" variants={dot} initial="initial" animate="animate" transition={{ delay: 0.3 }} />
      </div>
    </div>
  );
};

export default TypingDots;
